import React, { useState } from "react";
import ConfirmDialog from "../../components/modal/ConfirmDialog";
import CustomTable from "../../components/table/CustomTable";
import TableAction from "../../components/table/tableAction";

const AdminTable = ({ data, onEdit, onDelete }) => {
  const [tempRow, setRow] = useState(null);

  const columns = [
    {
      label: "First Name",
      field: "firstName",
    },
    {
      label: "Last Name",
      field: "lastName",
    },
    {
      label: "Email",
      field: "email",
    },
    {
      label: "Actions",
      width: "15%",
      render: (rowData) => (
        <TableAction
          onEdit={() => onEdit(rowData)}
          onDelete={() => setRow(rowData)}
        />
      ),
    },
  ];

  return (
    <>
      <CustomTable columns={columns} data={data} />
      <ConfirmDialog
        open={Boolean(tempRow)}
        title="Are you sure?"
        content="Do you really want to delete this user?"
        type="error"
        onClose={() => setRow(null)}
        onClik={() => {
          onDelete(tempRow);
          setRow(null);
        }}
      />
    </>
  );
};

export default AdminTable;
